import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import extractDialogProps from 'components/extractDialogProps';
import Container from '@material-ui/core/Container';

import { useHistory, useLocation } from 'react-router-dom'

import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import DoneIcon from '@material-ui/icons/Done';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const confirmedStyle = {
  backgroundColor : "green"
};

export default function DocumentHistoryDialog(props) {
  const [dialogProps] = extractDialogProps(props);
  const {
    histories,
  } = props;

  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  // URLパラメータから現在選択されている帳票を判定(cidが無い時は最新が選択中)
  const params = new URLSearchParams(location.search);
  const cid = params.get("cid") ?? histories[0].contentId;
  
  return (
    <div>
      <Dialog
        {...dialogProps}
        aria-labelledby="mail-history-dialog-title"
        aria-describedby="mail-history-dialog-description"
      >
        <Container component="main" maxWidth="xs" className={classes.paper}>
          <List>
            {histories.map((item) => (
              <ListItem button key={item.contentId} selected={item.contentId == cid} onClick={() => history.push(`${location.pathname}?cid=${item.contentId}`)} >
                <ListItemAvatar>
                  <Avatar style={item.confirmed ? confirmedStyle : {}}>
                    <DoneIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={item.reason} secondary={item.uploadedAt} />
              </ListItem>
            ))}
          </List>
        </Container>
      </Dialog>
    </div>
  );
}